import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Card,
  Textarea,
  ProgressBar,
  Input,
} from '@salesforce/design-system-react';

const ConnectorInput = (props) => {
  return (
    <React.Fragment>
      <Card
        className="slds-m-top_x-small"
        heading={
          <span
            style={{ textTransform: 'capitalize', fontWeight: '400', fontSize: '20px', color: '#3c4043' }}
          >{`Edit ${props.milestone} Connector`}</span>
        }
      >
        <div className="slds-m-top_large">
          <ProgressBar id="progress-bar-success" className="slds-m-top_large" value={((props.title.length))} />
          <Input
            assistiveText={{ label: 'Title' }}
            placeholder="Connecter Title"
            maxLength="255"
            onChange={props.onChangeTitle}
            required
            value={props.title}
            styleInput={{
              backgroundColor: 'rgb(205, 239, 196)',
              borderRadius: '0',
            }}
          />
          <ProgressBar id="progress-bar-success" className="slds-m-top_large" value={((props.content.length) / 255 * 100)} />
          <Textarea
            assistiveText={{ label: 'Content' }}
            placeholder="Connecter Content"
            onChange={props.onChangeContent}
            maxLength="255"
            required
            value={props.content}
            className="milestone-connector-background milestone-connector-height"
          />
          <div className="slds-clearfix">
            <div className="slds-float_right slds-p-right_small">
              <Button
                label="Update Connector"
                variant="brand"
                onClick={props.onAdd}
                className="slds-m-vertical_small"
              />
            </div>
          </div>
        </div>
      </Card>
    </React.Fragment>
  );
};

ConnectorInput.propTypes = {
  title: PropTypes.string.isRequired,
  onChangeTitle: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  onChangeContent: PropTypes.func.isRequired,
  milestoneStep: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default ConnectorInput;
